<template>
    <v-container fluid class="incidente-root">
        <h2>Reporte dinámico de gráficos</h2>

        <!-- SELECCIONAR EL CAMPO Y EL GRAFICO -->
        <v-card class="pa-3 mb-3 filtros-card" outlined>
            <v-row dense>
                <v-col cols="12" md="3">
                    <v-select v-model="campoGrafico" :items="camposDisponibles" item-text="text" item-value="value" label="Campo a graficar" outlined dense />
                </v-col>
                <v-col cols="12" md="3">
                    <v-select v-model="tipoGrafico" :items="tiposGrafico" item-text="text" item-value="value" label="Tipo de gráfico" outlined dense />
                </v-col>
                <!-- <v-col cols="12" md="2">
                    <v-select v-model="top" :items="[5, 10, 15, 20, 30, 50]" label="Top" outlined dense />
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field v-model="search" label="Buscar funcionario" append-icon="mdi-magnify" outlined dense clearable />
                </v-col> -->
            </v-row>
        </v-card>

        <!-- FILTROS -->
        <v-card class="pa-3 mb-3 filtros-card" outlined>
            <v-row dense align="center">
                <!-- <v-col cols="12" md="4">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por nombres, apellidos, correo o documento" outlined dense clearable />
                </v-col> -->
                <v-col cols="12" md="2">
                    <v-select v-model="filtros.oid_estado" :items="Lestado" item-text="n_estado" item-value="oid" label="Estado" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete v-model="filtros.oid_grado" :items="Lgrado" item-text="nombre" item-value="oid" label="Grado" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete v-model="filtros.oid_unidad" :items="Lunidad" item-text="nombre" item-value="oid" label="Unidad" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete v-model="filtros.oid_destino" :items="Ldestino" item-text="nombre" item-value="oid" label="Destino" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete v-model="filtros.oid_categoria" :items="Lcas" item-text="nombre" item-value="oid" label="Categoria CAS" outlined dense multiple clearable />
                </v-col>

                <v-col cols="12" md="2" class="text-right">
                    <v-btn text color="#5e672c" @click="verFiltros = !verFiltros">
                        <v-icon left small>mdi-filter-variant</v-icon>
                        Más filtros
                    </v-btn>
                </v-col>
            </v-row>
            <v-expand-transition>
                <div v-if="verFiltros" class="mt-3">
                    <v-divider class="mb-3"></v-divider>
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_depto" :items="LDepto" item-text="nombre" item-value="oid" label="Departamento" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_ciudad" :items="LCiudad" item-text="nombre" item-value="oid" label="Ciudad" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="filtros.oid_genero" :items="Catalogo.Genero" item-text="nombre" item-value="oid" label="Género" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="filtros.oid_estado_civil" :items="Catalogo.EstadoCivil" item-text="nombre" item-value="oid" label="Estado civil" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_cargo" :items="Lcargo" item-text="nombre" item-value="oid" label="Cargo" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_frontera" :items="Lfrontera" item-text="nombre" item-value="oid" label="Frontera" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_funciones" :items="Lfunciones" item-text="nombre" item-value="oid" label="Función Policial" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.grado_policial" :items="Lgpolicial" item-text="nombre" item-value="oid" label="Grado Policial" outlined dense multiple clearable />
                        </v-col>
                    </v-row>
                </div>
            </v-expand-transition>
        </v-card>

        <!-- BOTONES -->
        <v-row class="mb-3" align="center">
            <v-col cols="6">
                <v-btn small color="#5e672c" dark @click="listar">
                    <v-icon left small>mdi-refresh</v-icon>
                    Actualizar
                </v-btn>
                <v-btn small color="#e4b510" dark class="ml-2" @click="limpiarFiltros">
                    <v-icon left small>mdi-filter-remove</v-icon>
                    Limpiar filtros
                </v-btn>
            </v-col>

            <v-col cols="6" class="text-right">
                <v-btn small color="#e4b510" dark @click="descargarImagen">
                    <v-icon left small>mdi-download</v-icon>
                    Descargar PNG
                </v-btn>
            </v-col>
        </v-row>

        <!-- GRAFICO -->
        <v-card class="chart-card pa-4">
            <h3>{{ tituloGrafico }}</h3>

            <div class="chart-wrap">
                <canvas id="chartDinamico"></canvas>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';

import {
    Chart,
    PieController,
    BarController,
    ArcElement,
    BarElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale
} from 'chart.js';

import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
    PieController,
    BarController,
    ArcElement,
    BarElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    ChartDataLabels
);

import {
    loadAll,
    setDatos,
    getPaises,
    getDeptos,
    getCiudades,
    getPaisN,
    getDeptoN,
    getCiudadN,
    getOptionsByCodigo,
    getNameById
} from '@/utils/catalogo';

import { setEstados } from '@/utils/validators';

export default {
    data() {
        return {
            datos: [],
            chart: null,
            search: '',
            campoGrafico: 'oid_grado',
            tipoGrafico: 'bar',
            top: 10,
            Lgrado: [], Lcargo: [], Lunidad: [], Ldestino: [], Lcas: [], Lfrontera: [], Lfunciones: [], Lgpolicial: [], Lestado: [],
            LPais: [], LDepto: [], LCiudad: [],
            Catalogo: {
                Genero: [],
                EstadoCivil: [],
                Nacionalidad: [],
                TipoDocumento: [],
                TipoSangre: [],
            },
            tiposGrafico: [
                { text: 'Barra vertical', value: 'bar' },
                { text: 'Barra horizontal', value: 'bar-horizontal' },
                { text: 'Torta', value: 'pie' }
            ],
            camposDisponibles: [
                { text: 'Ciudad', value: 'oid_ciudad' },
                { text: 'Departamento', value: 'oid_depto' },
                { text: 'País', value: 'oid_pais' },
                { text: 'Grado', value: 'oid_grado' },
                { text: 'Cargo', value: 'oid_cargo' },
                { text: 'Unidad', value: 'oid_unidad' },
                { text: 'Destino', value: 'oid_destino' },
                { text: 'Estado', value: 'oid_estado' },
                { text: 'Género', value: 'oid_genero' },
                { text: 'Estado civil', value: 'oid_estado_civil' },
                { text: 'Categoría CAS', value: 'oid_categoria' },
                { text: 'Frontera', value: 'oid_frontera' },
                { text: 'Función policial', value: 'oid_funciones' },
                { text: 'Grado policial', value: 'grado_policial' },
                { text: 'Tipo documento', value: 'oid_tipo_documento' },
                { text: 'Tipo sangre', value: 'oid_tipo_sangre' }
            ],
            verFiltros: false,
            filtros: {
                oid_estado: [],
                oid_grado: [],
                oid_unidad: [],
                oid_genero: [],
                oid_estado_civil: [],
                oid_cargo: [],
                oid_destino: [],
                oid_categoria: [],
                oid_frontera: [],
                oid_funciones: [],
                grado_policial: [],
                oid_ciudad: [],
                oid_depto: []
            },
        };
    },
    computed: {
        tituloGrafico() {
            const campo = this.camposDisponibles.find(x => x.value === this.campoGrafico);
            return campo ? `Funcionarios por ${campo.text}` : 'Reporte dinámico';
        },
        datosFiltrados() {
            let data = this.datos || [];

            const search = (this.search || '').toLowerCase().trim();

            if (search) {
                data = data.filter(x => {
                    const texto = `
                        ${x.nombres || ''}
                        ${x.primero_apellido || ''}
                        ${x.segundo_apellido || ''}
                        ${x.documento || ''}
                        ${x.correo || ''}
                        ${x.telefono || ''}
                    `.toLowerCase();

                    return texto.includes(search);
                });
            }

            data = this.aplicarFiltroMultiple(data, 'oid_estado', this.filtros.oid_estado);
            data = this.aplicarFiltroMultiple(data, 'oid_grado', this.filtros.oid_grado);
            data = this.aplicarFiltroMultiple(data, 'oid_unidad', this.filtros.oid_unidad);
            data = this.aplicarFiltroMultiple(data, 'oid_genero', this.filtros.oid_genero);
            data = this.aplicarFiltroMultiple(data, 'oid_estado_civil', this.filtros.oid_estado_civil);
            data = this.aplicarFiltroMultiple(data, 'oid_cargo', this.filtros.oid_cargo);
            data = this.aplicarFiltroMultiple(data, 'oid_destino', this.filtros.oid_destino);
            data = this.aplicarFiltroMultiple(data, 'oid_categoria', this.filtros.oid_categoria);
            data = this.aplicarFiltroMultiple(data, 'oid_frontera', this.filtros.oid_frontera);
            data = this.aplicarFiltroMultiple(data, 'oid_funciones', this.filtros.oid_funciones);
            data = this.aplicarFiltroMultiple(data, 'grado_policial', this.filtros.grado_policial);
            data = this.aplicarFiltroMultiple(data, 'oid_ciudad', this.filtros.oid_ciudad);
            data = this.aplicarFiltroMultiple(data, 'oid_depto', this.filtros.oid_depto);

            return data;
        },
        datosGrafico() {
            const map = {};

            this.datosFiltrados.forEach(item => {
                const key = this.obtenerValorCampo(item, this.campoGrafico);
                const label = this.obtenerNombreCampo(this.campoGrafico, key);

                map[label] = (map[label] || 0) + 1;
            });

            const items = Object.entries(map)
                .map(([label, value]) => ({ label, value }))
                .sort((a, b) => b.value - a.value)
                .slice(0, this.top);

            return {
                labels: items.map(x => x.label),
                values: items.map(x => x.value)
            };
        }
    },
    watch: {
        campoGrafico() {
            this.$nextTick(() => this.renderChart());
        },
        tipoGrafico() {
            this.$nextTick(() => this.renderChart());
        },
        top() {
            this.$nextTick(() => this.renderChart());
        },
        search() {
            this.$nextTick(() => this.renderChart());
        },
        filtros: {
            deep: true,
            handler() {
                this.$nextTick(() => this.renderChart());
            }
        }
    },
    async mounted() {
        await this.cargarCatalogos();
        await this.listar();
        this.$nextTick(() => this.renderChart());
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    },
    methods: {
        async cargarCatalogos() {
            await loadAll();
            await setDatos();

            this.LPais = getPaises();
            this.LDepto = getDeptos();
            this.LCiudad = getCiudades();

            this.Catalogo.Genero = getOptionsByCodigo('Genero');
            this.Catalogo.EstadoCivil = getOptionsByCodigo('EstadoCivil');
            this.Catalogo.Nacionalidad = getOptionsByCodigo('Nacionalidad');
            this.Catalogo.TipoDocumento = getOptionsByCodigo('TipoDocumento');
            this.Catalogo.TipoSangre = getOptionsByCodigo('TipoSangre');

            const [g, c, u, d, cas, fb, fun, gp] = await Promise.all([
                axios.get('api/Grados/Listar'),
                axios.get('api/Cargos/Listar'),
                axios.get('api/Unidads/Listar'),
                axios.get('api/Destinos/Listar'),
                axios.get('api/Categoria_cas/Listar'),
                axios.get('api/FonteraBonos/Listar'),
                axios.get('api/Funciones/Listar'),
                axios.get('api/GradoPolicials/Listar')
            ]);

            this.Lgrado = g.data || [];
            this.Lcargo = c.data || [];
            this.Lunidad = u.data || [];
            this.Ldestino = d.data || [];
            this.Lcas = cas.data || [];
            this.Lfrontera = fb.data || [];
            this.Lfunciones = fun.data || [];
            this.Lgpolicial = gp.data || [];
            this.Lestado = await setEstados();
        },

        async listar() {
            try {
                const pageSize = 1000;
                let page = 1;
                let total = 0;
                let todos = [];

                do {
                    const response = await axios.get('api/PersonaInfoGenerals/ListarCompleto', {
                        params: {
                            page,
                            pageSize
                        }
                    });

                    const data = response.data.data || [];
                    total = response.data.total || 0;

                    todos = todos.concat(data);
                    page++;
                } while (todos.length < total);

                this.datos = todos;

                this.$nextTick(() => this.renderChart());
            } catch (error) {
                console.error(error);
            }
        },

        renderChart() {
            if (this.chart) {
                this.chart.destroy();
                this.chart = null;
            }

            const canvas = document.getElementById('chartDinamico');
            if (!canvas) return;

            const grouped = this.datosGrafico;

            const chartType = this.tipoGrafico === 'pie' ? 'pie' : 'bar';

            this.chart = new Chart(canvas.getContext('2d'), {
                type: chartType,
                data: {
                    labels: grouped.labels,
                    datasets: [{
                        data: grouped.values,
                        backgroundColor: this.getColors(grouped.values.length),
                        borderColor: '#ffffff',
                        borderWidth: 1
                    }]
                },
                options: {
                    indexAxis: this.tipoGrafico === 'bar-horizontal' ? 'y' : 'x',
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: this.tipoGrafico === 'pie',
                            position: 'bottom'
                        },
                        datalabels: {
                            anchor: this.tipoGrafico === 'pie' ? 'center' : 'end',
                            align: this.tipoGrafico === 'pie'
                                ? 'center'
                                : this.tipoGrafico === 'bar-horizontal'
                                    ? 'right'
                                    : 'top',
                            color: this.tipoGrafico === 'pie' ? '#fff' : '#303641',
                            font: {
                                size: 11,
                                weight: 'bold'
                            },
                            formatter: (value, context) => {
                                if (this.tipoGrafico !== 'pie') return value;

                                const total = context.chart.data.datasets[0].data
                                    .reduce((a, b) => a + b, 0) || 1;

                                return `${((value / total) * 100).toFixed(1)}%`;
                            }
                        }
                    },
                    scales: chartType === 'pie'
                        ? {}
                        : {
                            x: {
                                beginAtZero: true
                            },
                            y: {
                                beginAtZero: true
                            }
                        }
                }
            });
        },

        descargarImagen() {
            const canvas = document.getElementById('chartDinamico');
            if (!canvas) return;

            const link = document.createElement('a');
            link.download = `Grafico_Dinamico_${new Date().toISOString().substring(0, 10)}.png`;
            link.href = canvas.toDataURL('image/png', 1);
            link.click();
        },

        obtenerValorCampo(item, campo) {
            const valor = item[campo];

            if (valor === null || valor === undefined || valor === '') {
                return 'SIN_DATO';
            }

            return String(valor);
        },

        obtenerNombreCampo(campo, valor) {
            if (valor === 'SIN_DATO') return 'Sin dato';

            const id = Number(valor);

            switch (campo) {
                case 'oid_ciudad':
                    return getCiudadN(id) || 'Sin ciudad';

                case 'oid_depto':
                    return getDeptoN(id) || 'Sin departamento';

                case 'oid_pais':
                    return getPaisN(id) || 'Sin país';

                case 'oid_grado':
                    return this.buscarNombre(this.Lgrado, id);

                case 'oid_cargo':
                    return this.buscarNombre(this.Lcargo, id);

                case 'oid_unidad':
                    return this.buscarNombre(this.Lunidad, id);

                case 'oid_destino':
                    return this.buscarNombre(this.Ldestino, id);

                case 'oid_estado':
                    return this.buscarNombreEstado(id);

                case 'oid_categoria':
                    return this.buscarNombre(this.Lcas, id);

                case 'oid_frontera':
                    return this.buscarNombre(this.Lfrontera, id);

                case 'oid_funciones':
                    return this.buscarNombre(this.Lfunciones, id);

                case 'grado_policial':
                    return this.buscarNombre(this.Lgpolicial, id);

                case 'oid_genero':
                case 'oid_estado_civil':
                case 'oid_tipo_documento':
                case 'oid_tipo_sangre':
                    return getNameById(id) || 'Sin dato';

                default:
                    return valor || 'Sin dato';
            }
        },

        buscarNombre(lista, id) {
            const item = (lista || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        buscarNombreEstado(id) {
            const item = (this.Lestado || []).find(x => Number(x.oid) === Number(id));
            return item ? item.n_estado : 'Sin dato';
        },

        getColors(length) {
            const palette = [
                '#5e672c',
                '#838858',
                '#c9a538',
                '#e4b510',
                '#727b4a',
                '#384018',
                '#8fd0df',
                '#3a3f4a'
            ];

            return Array.from({ length }, (_, i) => palette[i % palette.length]);
        },

        aplicarFiltroMultiple(data, campo, valores) {
            if (!valores || valores.length === 0) return data;

            return data.filter(x =>
                valores.map(Number).includes(Number(x[campo]))
            );
        },

        limpiarFiltros() {
            this.search = '';

            this.filtros = {
                oid_estado: [],
                oid_grado: [],
                oid_unidad: [],
                oid_genero: [],
                oid_estado_civil: [],
                oid_cargo: [],
                oid_destino: [],
                oid_categoria: [],
                oid_frontera: [],
                oid_funciones: [],
                grado_policial: [],
                oid_ciudad: [],
                oid_depto: []
            };

            this.$nextTick(() => this.renderChart());
        },
    }
};
</script>

<style scoped>
.rep-root {
    background: #f7f8f3;
    min-height: calc(100vh - 80px);
    padding: 20px;
}

h2 {
    color: #5e672c;
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 16px;
}

h3 {
    color: #5e672c;
    font-size: 22px;
    font-weight: 800;
    text-align: center;
    margin-bottom: 16px;
}

.filtros-card {
    border-radius: 14px !important;
    background: #ffffff !important;
}

.chart-card {
    border-radius: 18px !important;
    background: #ffffff !important;
    border: 1px solid rgba(108, 117, 51, 0.14) !important;
    box-shadow: 0 12px 28px rgba(59, 71, 33, 0.08);
}

.chart-wrap {
    position: relative;
    height: 520px;
}
</style>